import { useContext } from 'react';

import { useQuery } from '@tanstack/react-query';

import Axios from 'axios';
import { queryClient } from 'QueryClientProvider';

import { ListContext } from '@contexts/ListContext';

const useAgencyModels = (ID) => {
    const { cachedList } = useContext(ListContext);
    const modelAgencyLabels = cachedList.modelAgencyLabels.items;
    const disableQuery = !ID || isNaN(parseInt(ID));
    const intID = !disableQuery ? parseInt(ID) : null;
    return useQuery({
        queryKey: ['agencyModels', intID],
        queryFn: () => Axios.get(`/contacts/agencymodels/${intID}`),
        select: (data) =>
            data?.map((item) => ({
                ...item,
                Label: modelAgencyLabels.find((l) => l.ID === item.ModelAgencyLabelID) || null,
            })),
        staleTime: 60000,
        cacheTime: 60000,
        enabled: !disableQuery,
    });
};

const forceReloadAgencyModels = (ID) => {
    const intID = Number(ID);
    queryClient.invalidateQueries({ queryKey: ['agencyModels', intID] });
};

export { useAgencyModels, forceReloadAgencyModels };
